module.exports = __webpack_public_path__ + "static/media/back_of_right_hand_failed.937175e4.svg";